import Vue from 'vue'
import Router from 'vue-router'
import Index from 'pages/index'
import Login from 'pages/login'
import Market from 'pages/market'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
  routes: [
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/market',
      name: 'Market',
      component: Market
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js